import { gql, useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import moment from "moment";
import { ARCHIVE_CODES } from "../ArchivePriceForm";

const FETCH_PRODUCT_COST_HISTORY = gql`
  query FETCH_PRODUCT_COST_HISTORY($productIds: [ID], $company: String) {
    productPrices(productIds: $productIds, company: $company) {
      total
      results {
        id
        minQty
        price
        currency
        supplierUpdatedAt
        factory {
          id
          nickName
        }
        archivedAt
        archivedCode
        archivedNotes
      }
    }
  }
`;

function getArchiveCodeDescription(code) {
  const foundCode = ARCHIVE_CODES.find((i) => i.code === code);
  if (foundCode) return foundCode.description;
  return "-";
}

const ProductCostHistoryView = ({ product, company }) => {
  const { loading, error, data } = useQuery(FETCH_PRODUCT_COST_HISTORY, {
    variables: { productIds: [product.id], company },
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;

  if (error) return <Errors error={error} />;

  const prices = [...data.productPrices.results].sort((a, b) => {
    return new Date(b.supplierUpdatedAt) - new Date(a.supplierUpdatedAt);
  });

  return (
    <div className="text-sm -mx-2">
      <table className="whitespace-nowrap">
        <thead>
          <tr>
            <th>Date</th>
            <th>Supplier</th>
            <th className="w-1/2">Archived</th>
            <th className="text-right">Min QTY</th>
            <th className="text-right">Price</th>
          </tr>
        </thead>
        <tbody>
          {prices.map((price) => (
            <tr key={price.id} className="border-y dark:border-gray-700">
              <td>{moment(price.supplierUpdatedAt).format("YYYY-MM-DD")}</td>
              <td>{price.factory?.nickName}</td>
              <td className="">
                {price.archivedAt ? (
                  <div>
                    <div>{moment(price.archivedAt).format("YYYY-MM-DD")}</div>
                    <div className="text-xs font-semibold">
                      {getArchiveCodeDescription(price.archivedCode)}
                    </div>
                    <div className=" opacity-70 text-xs whitespace-normal">
                      {price.archivedNotes}
                    </div>
                  </div>
                ) : (
                  "-"
                )}
              </td>
              <td className="text-right">{price.minQty}</td>
              <td className="text-right font-code">
                {price.currency} {price.price.toFixed(3)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductCostHistoryView;
